import type { ReactNode } from 'react'

import { Provider } from './disclosureSectionContext'
type Props = {
  isOpen: boolean
  children: ReactNode
}

const DisclosureSectionProvider = ({ isOpen, children }: Props) => (
  <Provider
    value={{
      isOpen,
    }}
  >
    {children}
  </Provider>
)

export { DisclosureSectionProvider }
